import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MapFull from './MapFull';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<MapFull />);
